import { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'

export class UpdateCompanyPeriodsEntity {
  applyToActiveNotLockedMeals?: boolean
  periods?: {
    id?: number | null
    time?: string
    timeDayOfWeek?: DayOfWeek
    dayOfWeek?: DayOfWeek
  }[]
}
